import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumSwedishDutyTariff implements BaseEnumType {
  private static allValues: EnumSwedishDutyTariff[] = []; // make sure this is top-most
  
  public static none = new EnumSwedishDutyTariff(0, "None", "enum_swedish_duty_tariff_none");
  public static unknown = new EnumSwedishDutyTariff(1, "Unknown", "enum_swedish_duty_tariff_unknown");
  public static beer_B000 = new EnumSwedishDutyTariff(2, "Beer_B000", "enum_swedish_duty_tariff_beer__b000");
  public static stillWine_W200 = new EnumSwedishDutyTariff(3, "StillWine_W200", "enum_swedish_duty_tariff_still_wine__w200");
  public static sparklingWine_W300 = new EnumSwedishDutyTariff(4, "SparklingWine_W300", "enum_swedish_duty_tariff_sparkling_wine__w300");
  public static intermediate_I000 = new EnumSwedishDutyTariff(5, "Intermediate_I000", "enum_swedish_duty_tariff_intermediate__i000");
  public static spirits_S200 = new EnumSwedishDutyTariff(6, "Spirits_S200", "enum_swedish_duty_tariff_spirits__s200");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumSwedishDutyTariff.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumSwedishDutyTariff.none; }
  public isUnknown() { return this === EnumSwedishDutyTariff.unknown; }
  public isBeer_B000() { return this === EnumSwedishDutyTariff.beer_B000; }
  public isStillWine_W200() { return this === EnumSwedishDutyTariff.stillWine_W200; }
  public isSparklingWine_W300() { return this === EnumSwedishDutyTariff.sparklingWine_W300; }
  public isIntermediate_I000() { return this === EnumSwedishDutyTariff.intermediate_I000; }
  public isSpirits_S200() { return this === EnumSwedishDutyTariff.spirits_S200; }

  public static getValues(): readonly EnumSwedishDutyTariff[] {
    return EnumSwedishDutyTariff.allValues;
  }

  public static getValuesExcept0(): readonly EnumSwedishDutyTariff[] {
    return EnumSwedishDutyTariff.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumSwedishDutyTariff {
    const found = EnumSwedishDutyTariff.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumSwedishDutyTariff - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumSwedishDutyTariff): EnumSwedishDutyTariff {
    const found = name ? EnumSwedishDutyTariff.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumSwedishDutyTariff - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumSwedishDutyTariff>): boolean {
    return this.key === other?.key;
  }
}